import { IBase, IVehicleSchedule, IVehicleScheduleConflict, IVehicleScheduleTrip, IVehicleScheduleTripAssignment } from 'src/app/models';
import { ScheduleGroupBy } from 'src/app/models/enums';
import { scheduleRowField } from './scheduleChanges';

export function overlapsInTime(a: IVehicleScheduleTrip, b: IVehicleScheduleTrip): boolean {
  return a.startDateTime < b.endDateTime && b.startDateTime < a.endDateTime;
}

export function tripAssignments(schedules: IVehicleSchedule[], groupBy: ScheduleGroupBy): IVehicleScheduleTripAssignment[] {
  const field = scheduleRowField(groupBy);
  return schedules.flatMap((schedule) =>
    schedule.availabilities.flatMap((availability) =>
      availability.trips.map((trip) => {
        const row: IBase = { id: schedule.id, name: schedule.name };
        if (field === 'driver') {
          return { trip, driver: row, vehicle: trip.vehicle ?? availability.vehicle };
        }
        return { trip, vehicle: row, driver: trip.driver ?? availability.driver };
      }),
    ),
  );
}

function sameResource(a?: IBase, b?: IBase): boolean {
  return a?.id !== undefined && a.id === b?.id;
}

export function findScheduleConflicts(
  checked: IVehicleScheduleTripAssignment[],
  candidates: IVehicleScheduleTripAssignment[],
): IVehicleScheduleConflict[] {
  const conflicts = new Map<number | undefined, IVehicleScheduleConflict>();
  checked.forEach((item) =>
    candidates
      .filter(
        (candidate) =>
          candidate.trip.id !== item.trip.id &&
          !conflicts.has(candidate.trip.id) &&
          overlapsInTime(item.trip, candidate.trip) &&
          (sameResource(item.driver, candidate.driver) || sameResource(item.vehicle, candidate.vehicle)),
      )
      .forEach((candidate) => conflicts.set(candidate.trip.id, { conflictingTrip: candidate.trip })),
  );
  return [...conflicts.values()].sort(
    (a, b) => a.conflictingTrip.startDateTime.getTime() - b.conflictingTrip.startDateTime.getTime(),
  );
}
